import { API } from "../core/config";
import client from "../core/http/client";
import { Email } from "../models/email";
import { Phone } from "../models/phone";
import { UserProfileData } from "../models/user";
import { ApiResponse } from "../shared/types/api";

class ProfileApi {

    async getProfile(): Promise<ApiResponse<{ user: UserProfileData }>> {
        // console.log('[ProfileApi] getProfile appelé');
        try {
            const response = await client.get<ApiResponse<{ user: UserProfileData }>>(API.ACCOUNT.PROFILE);
            // console.log('[ProfileApi] getProfile réponse :', response.data);
            return response.data;
        } catch (error) {
            // console.error('[ProfileApi] getProfile erreur :', error);
            throw error;
        }
    }

    async getEmails(): Promise<ApiResponse<Email[]>> {
        // console.log('[ProfileApi] getEmails appelé');
        try {
            const response = await client.get<ApiResponse<Email[]>>(API.ACCOUNT.EMAILS);
            // console.log('[ProfileApi] getEmails réponse :', response.data);
            return response.data;
        } catch (error) {
            // console.error('[ProfileApi] getEmails erreur :', error);
            throw error;
        }
    }

    async getPhones(): Promise<ApiResponse<Phone[]>> {
        // console.log('[ProfileApi] getPhones appelé');
        try {
            const response = await client.get<ApiResponse<Phone[]>>(API.ACCOUNT.PHONES);
            // console.log('[ProfileApi] getPhones réponse :', response.data);
            return response.data;
        } catch (error) {
            // console.error('[ProfileApi] getPhones erreur :', error);
            throw error;
        }
    }


    async updateProfile(data: { display_name?: string; locale?: string; timezone?: string }): Promise<ApiResponse<null>> {
        const response = await client.patch<ApiResponse<null>>(
            API.ACCOUNT.PROFILE,
            data
        );
        return response.data;
    }

    async addEmail(email: string): Promise<ApiResponse<Email>> {
        const response = await client.post<ApiResponse<Email>>(API.ACCOUNT.EMAILS, { email });
        return response.data;
    }

    async setPrimaryEmail(emailId: string, payload?: { code?: string }): Promise<ApiResponse<null>> {
        const response = await client.patch<ApiResponse<null>>(
            `${API.ACCOUNT.EMAILS}/${emailId}/primary`,
            payload || {}
        );
        return response.data;
    }

    async verifyEmail(code: string): Promise<ApiResponse<null>> {
        const response = await client.post<ApiResponse<null>>(
            `${API.ACCOUNT.EMAILS}/verify`,
            { code }
        );
        return response.data;
    }

    async resendVerificationEmail(emailId: string): Promise<ApiResponse<null>> {
        const response = await client.post<ApiResponse<null>>(
            `${API.ACCOUNT.EMAILS}/${emailId}/resend-verification`
        );
        return response.data;
    }

    async deleteEmail(emailId: string): Promise<ApiResponse<null>> {
        const response = await client.delete<ApiResponse<null>>(
            `${API.ACCOUNT.EMAILS}/${emailId}`
        );
        return response.data;
    }


    async addPhone(phone: string, country_code: string): Promise<ApiResponse<Phone>> {
        const response = await client.post<ApiResponse<Phone>>(API.ACCOUNT.PHONES, { phone, country_code });
        return response.data;
    }

    async setPrimaryPhone(phoneId: string, payload?: { code?: string }): Promise<ApiResponse<null>> {
        const response = await client.patch<ApiResponse<null>>(
            `${API.ACCOUNT.PHONES}/${phoneId}/primary`,
            payload || {}
        );
        return response.data;
    }

    async verifyPhone(phoneId: string, code: string): Promise<ApiResponse<null>> {
        const response = await client.post<ApiResponse<null>>(
            `${API.ACCOUNT.PHONES}/${phoneId}/verify`,
            { code }
        );
        return response.data;
    }

    async deletePhone(phoneId: string): Promise<ApiResponse<null>> {
        const response = await client.delete<ApiResponse<null>>(
            `${API.ACCOUNT.PHONES}/${phoneId}`
        );
        return response.data;
    }

    // Avatar
    async uploadAvatar(file: File): Promise<ApiResponse<{ avatar_url: string }>> {
        const formData = new FormData();
        formData.append('file', file);
        const response = await client.post<ApiResponse<{ avatar_url: string }>>(
            API.ACCOUNT.AVATAR,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
        return response.data;
    }
}

export const profileApi = new ProfileApi();